<template>
    <div class="object-settings-container" v-if="config.display" :id="name">
        <fieldset>
            <legend><label-wrapper :label-settings="config"></label-wrapper></legend>
            <ul class="sub-setting-props">
                <li v-for="(option,key) in config.properties" :key="key">
                    <control
                        :name="name + '_' + key"
                        :prop-config="option"
                        :value="value[key]"
                        :values-map="valuesMap"
                        :disabled="config.disabled"
                        @update:value="value[key] = $event"
                        :recordId="recordId"
                    ></control>
                </li>
            </ul>
        </fieldset>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};
const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));
export const objectComponent = {
    editorSettings: editorSettings,
    data() {
        return {};
    },
    mixins: [controlMixins],
    components: {
        control: controlComponent
    },
    methods: {},
    watch: {
        value: {
            handler(value) {
                if (!this.value || typeof this.value !== 'object') this.value = {};
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:value', value);
                }
            },
            deep: true
        }
    }
};

export default objectComponent;
</script>

<style lang="css" scoped>
.object-settings-container {
    width: 100%;
}
.object-settings-container label {
    margin-bottom: 10px;
    display: block;
}
.sub-setting-props {
    padding-left: 0;
    list-style: none;
}
fieldset {
    padding: 5px 5px 5px 20px;
    border: 1px solid #ccc;
}
fieldset :deep(.label-wrapper) {
    margin-top: 4px;
}
</style>
